(function () {
  'use strict';

  var modal = document.getElementById('plz-social-modal');
  if (!modal) return;

  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  var openers = document.querySelectorAll('[data-plz-social-open]');
  var closeEls = modal.querySelectorAll('[data-plz-social-close]');
  var lastOpener = null;
  var scrollLockY = 0;
  var pinnedEls = [];

  function pinHeaderOnce() {
    var headerBottom = 0;

    ['.plz-announcement-bar-section', '.plz-header-section'].forEach(function (selector) {
      var el = document.querySelector(selector);
      if (!el) return;

      var rect = el.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;

      el.classList.add('plz-header--modal-pinned');
      el.style.setProperty('--plz-header-pinned-top', rect.top + 'px');
      pinnedEls.push(el);
      headerBottom = Math.max(headerBottom, rect.bottom);
    });

    document.documentElement.style.setProperty('--plz-pinned-header-bottom', headerBottom + 'px');
  }

  function unpinHeader() {
    pinnedEls.forEach(function (el) {
      el.classList.remove('plz-header--modal-pinned');
      el.style.removeProperty('--plz-header-pinned-top');
    });
    pinnedEls = [];
    document.documentElement.style.removeProperty('--plz-pinned-header-bottom');
  }

  function lockScroll() {
    scrollLockY = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('plz-scroll-locked');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('plz-scroll-locked');
    window.scrollTo(0, scrollLockY);
  }

  function open(opener) {
    lastOpener = opener || null;

    document.querySelectorAll('.plz-header-section').forEach(function (el) {
      el.classList.remove('shopify-section-header-hidden');
    });

    /* Measure + pin while sticky layout is still intact */
    pinHeaderOnce();
    lockScroll();

    var drawer = document.querySelector('.plz-header__drawer[open]');
    var drawerLayer = document.getElementById('plz-header-drawer-layer');
    if (drawer) drawer.open = false;
    if (drawerLayer) drawerLayer.hidden = true;
    document.body.classList.remove('plz-drawer-open');
    document.documentElement.classList.remove('plz-drawer-scroll-locked');
    document.querySelectorAll('.plz-header--modal-pinned').forEach(function (el) {
      el.classList.remove('plz-header--modal-pinned');
      el.style.removeProperty('--plz-header-pinned-top');
    });
    document.documentElement.style.removeProperty('--plz-pinned-header-bottom');

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-opening');
    document.body.classList.add('plz-social-modal-open');

    window.setTimeout(function () {
      modal.classList.remove('is-opening');
    }, 300);

    var focusTarget = modal.querySelector('.plz-social-modal__close');
    if (focusTarget) focusTarget.focus();
  }

  function close() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('plz-social-modal-open');
    unpinHeader();
    unlockScroll();

    if (lastOpener && typeof lastOpener.focus === 'function') {
      lastOpener.focus({ preventScroll: true });
    }
  }

  openers.forEach(function (opener) {
    opener.addEventListener('click', function (event) {
      event.preventDefault();
      open(opener);
    });
  });

  closeEls.forEach(function (el) {
    el.addEventListener('click', close);
  });

  function trapFocus(event) {
    if (modal.hidden) return;

    var focusable = modal.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.key !== 'Tab') return;

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      close();
      return;
    }
    trapFocus(event);
  });
})();
